import React from "react";
import { Container, Grid, Card } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import { BASE_URL } from "../../../../config/config";

const WhyChooseUsBlockChain = () => {
  const WHY_CHOOSE_US_IMAGE = `${BASE_URL}/about_why_choose_us.png`;

  return (
    <div className="whyChooseUsSection_portal">
      <Container>
        <h1 className="whyChooseUsTitle_portal">Why Domaincer</h1>
        <Grid container spacing={2} style={{ justifyContent: "center" }}>
          <Grid item xs={12} sm={3}>
            <div
              className="whyChooseColumnUpContainer_portal"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <h1 className="chooseTitle_portal">User friendly</h1>
              <h2 className="choosePara_portal">
                Maximize your online potential with our team's expertise in
                creating a strong and user-friendly web presence.
              </h2>
            </div>
            <div
              className="whyChooseColumnDownContainer_portal"
              data-aos="fade-right"
              data-aos-duration="1400"
            >
              <h1 className="chooseTitle_portal">Personalized Approach</h1>
              <h2 className="choosePara_portal">
                Customized solutions tailored to your needs and goals provide a
                more effective and engaging experience for users.
              </h2>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} className="chooseUsImageRow_portal">
            <img
              src={WHY_CHOOSE_US_IMAGE}
              alt="why choose us image 3d domaincer"
              className="chooseUsMiddleImg_portal floatingUpDown"
            />
          </Grid>

          <Hidden only={["sm", "lg", "md", "xl"]}>
            <Grid item xs={12} sm={3}>
              <div
                className="whyChooseColumn3UpContainer_portal"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <h1 className="chooseTitle_portal">Scalability</h1>
                <h2 className="choosePara_portal">
                  Our scalable blockchain platform uses advanced algorithms and
                  hardware to handle increasing workloads without performance
                  loss.
                </h2>
              </div>
              <div
                className="whyChooseColumn3DownContainer_portal"
                data-aos="fade-up"
                data-aos-duration="1400"
              >
                <h2 className="chooseTitle_portal">Outstanding Support</h2>
                <h3 className="choosePara_portal">
                  Domaincer provides professional support and top-notch
                  functionalities to help you succeed from start to finish.
                </h3>
              </div>
            </Grid>
          </Hidden>
          <Hidden only={["xs"]}>
            <Grid item xs={12} sm={3}>
              <div
                className="whyChooseColumn3UpContainer_portal"
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <h2 className="chooseTitle_portal">Scalability</h2>
                <h3 className="choosePara_portal">
                  Our scalable blockchain platform uses advanced algorithms and
                  hardware to handle increasing workloads without performance
                  loss.
                </h3>
              </div>
              <div
                className="whyChooseColumn3DownContainer_portal"
                data-aos="fade-left"
                data-aos-duration="1600"
              >
                <h2 className="chooseTitle_portal">Outstanding Support</h2>
                <h3 className="choosePara_portal">
                  Domaincer provides professional support and top-notch
                  functionalities to help you succeed from start to finish.
                </h3>
              </div>
            </Grid>
          </Hidden>
        </Grid>
      </Container>
    </div>
  );
};
export default WhyChooseUsBlockChain;
